import Styles from "./PlatformLabels.module.scss";
import {ReactComponent as AndroidIcon } from "../../../icons/platforms/android_new.svg"
import {ReactComponent as DesktopIcon } from "../../../icons/platforms/laptop.svg"
import {ReactComponent as WebIcon } from "../../../icons/platforms/website.svg"
import {ReactComponent as AIMLIcon } from "../../../icons/platforms/aiml.svg"
import {ReactComponent as ChromeIcon } from "../../../icons/platforms/chrome.svg"
import { APP_TYPE } from "../../../constants/constants";

interface PlatformLabelsTypes{
    type:number;
}

const PlatformLabels = ({type}:PlatformLabelsTypes) => {


    interface PlatformType{
        [key:number]:any;
    }

    const Platforms:PlatformType={
        0:{
            title:"Andoid",
            backgroundColor:"#FFFFFF",
            color:"#000000",
            icon:<AndroidIcon/>
        },
        1:{
            title:"Desktop",
            backgroundColor:"#FFFFFF",
            color:"#000000",
            icon:<DesktopIcon/>
        },
        2:{
            title:"Web Development",
            backgroundColor:"#FFFFFF",
            color:"#000000",
            icon:<WebIcon/>
        },
        3:{
            title:"AIML",
            backgroundColor:"#FFFFFF",
            color:"#000000",
            icon:<AIMLIcon/>
        },
        4:{
            title:"Chrome",
            backgroundColor:"#FFFFFF",
            color:"#000000",
            icon:<ChromeIcon/>
        }
    }

  return (
    <div className={Styles.badge} style={{
        backgroundColor:Platforms[type].backgroundColor,
        color:Platforms[type].color
    }}>
        <div className={Styles.icon}>{Platforms[type].icon}</div>
        <div className={Styles.label}>{Platforms[type].title}</div>
    </div>
  )
}

export default PlatformLabels
